export default (function (element) {
  if (!element) {
    return false;
  }

  if (element.offsetParent) {
    return true;
  }

  if (element.getBBox) {
    var box = element.getBBox();

    if (box.width || box.height) {
      return true;
    }
  }

  if (element.getBoundingClientRect) {
    var _box = element.getBoundingClientRect();

    if (_box.width || _box.height) {
      return true;
    }
  }

  return false;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-menu/node_modules/rc-util/es/Dom/isVisible.js
// module id = 675
// module chunks = 0